import { NativeSelect } from '@mantine/core'
import { useTranslation } from 'react-i18next'

import { Text } from 'src/components/Text/Text'
import { getEarliestShipmentDate } from 'src/functions/dates/getEarliestShipmentDate'

import styles from './SellingPlanInterval.module.scss'

import type { ProductSubscriptionSellingPlans } from 'src/types/Subscription'

interface SellingPlanIntervalProps {
  sellingPlanInterval: number
  setSellingPlanInterval: (interval: number) => void
  coffeeSubscriptionSellingPlans: ProductSubscriptionSellingPlans
}

export const SellingPlanInterval = ({
  sellingPlanInterval,
  setSellingPlanInterval,
  coffeeSubscriptionSellingPlans,
}: SellingPlanIntervalProps) => {
  const { t } = useTranslation()

  const { sellingPlans } = coffeeSubscriptionSellingPlans

  if (!sellingPlans) return null

  const dropdownOptions = Object.values(sellingPlans).map((plan) => ({
    'value': plan.interval.toString(),
    'label': `${plan.interval} ${t('pdp.subscription.weeks')}`,
    'data-analytics-id': 'select-delivery-interval',
  }))

  return (
    <div className={styles.container}>
      <div className={styles.textRow}>
        <Text variant="span" bold className={styles.label}>
          {t('pdp.subscription.deliveryInterval')}
        </Text>

        <Text variant="span" small className={styles.supportText} suppressHydrationWarning>
          {t('pdp.subscription.firstShipment', { date: getEarliestShipmentDate() })}
        </Text>
      </div>

      <div className={styles.sellingPlans}>
        <NativeSelect
          data={dropdownOptions}
          value={sellingPlanInterval.toString()}
          onChange={(event) => setSellingPlanInterval(parseInt(event.target.value, 10))}
          data-analytics-id="dropdown-delivery-interval"
        />
      </div>
    </div>
  )
}
